import { LoadingOutlined } from "@ant-design/icons";
import { message, Modal, Spin } from "antd";
import { ReactElement } from "react";
import { useParams } from "react-router-dom";
import { IConfirmModalChangeStatusProps } from "../../../../../../interfaces/props/IConfirmModalChangeStatusProps";
import { useSetApplicationBankStatusOnlyNewInfoStatusMutation } from "../../../../../../store/api/applicationBankApi/applicationBank.api";
import { SetApplicationBankStatusResponse } from "../../../../../../store/api/types/applicationBankApiTypes";

import classes from "./ConfirmModalChangeStatus.module.css";

const confirmModalModeChildren = {
  resigning: "Направить на повторное подписание?",
  return_from_reject: "Вернуть заявку на доработку?",
};

/**
 * Сообщения в снекбарах об успешной смене статусов в зависимости от статуса заявок
 */
const successMessagesChangeStatus: {
  resigning: string;
  return_from_reject: string;
} = {
  resigning: "Заявка отправлена на повторное подписание",
  return_from_reject: "Заявка возращена на доработку",
};

/**
 * Компонент модального окна для подтверждения изменения статуса заявки.
 * @param {IConfirmModalChangeStatusProps} props - Свойства компонента, включающие режим и функцию закрытия модального окна.
 */
export function ConfirmModalChangeStatus(
  props: IConfirmModalChangeStatusProps,
): ReactElement {
  const { mode, open, closeModal, onCancel } = props;
  const { applicationId, applicationBankId } = useParams();
  const [
    setApplicationBankStatusOnlyStatusInfoFromServer,
    { isLoading: isLoadingChangeStatus },
  ] = useSetApplicationBankStatusOnlyNewInfoStatusMutation();

  async function handleOk() {
    if (mode && applicationId && applicationBankId) {
      try {
        const modeURLActions = {
          resigning: SetApplicationBankStatusResponse["resigning"],
          return_from_reject:
            SetApplicationBankStatusResponse["return_from_reject"],
        };

        await setApplicationBankStatusOnlyStatusInfoFromServer({
          applicationId: Number(applicationId),
          applicationBankId: Number(applicationBankId),
          action: modeURLActions[mode],
        }).unwrap();

        message.success(successMessagesChangeStatus[mode]);
      } catch (error) {
        if (error instanceof Error) message.error(error.message);
        else message.error("Произошла неизвестная ошибка");
      }

      closeModal();
    }
  }

  const confirmModalOkButtonChild = isLoadingChangeStatus ? (
    <Spin
      indicator={<LoadingOutlined className="loader-white" spin />}
      size="small"
    />
  ) : undefined;

  return (
    <Modal
      okText={confirmModalOkButtonChild}
      onOk={handleOk}
      onCancel={onCancel}
      okButtonProps={{
        className: classes.confirmModalOk,
        disabled: isLoadingChangeStatus,
      }}
      open={open}
    >
      {mode && confirmModalModeChildren[mode]}
    </Modal>
  );
}
